export const stellarCommunityFundData = {
  sectionLabel: 'Our Work on Stellar',
  title: `Funded to Build the Network's Infrastructure`,
  intro: `Plenty of development shops will tell you they know an ecosystem. We can show it. The Stellar Development Foundation has awarded Rumble Fish two Stellar Community Fund grants to build infrastructure that other projects on the network depend on. That's the ecosystem putting its own money behind our work.`,
  grants: [
    {
      badge: 'SCF #41 · $131,200',
      title: 'Soroban-First Block Explorer',
      description: `Soroban hosts a growing share of Stellar's DeFi, new token standards, and complex contract interactions, but most existing explorers display its data as raw, unreadable XDR. We're building a full-stack, Soroban-first block explorer that decodes on-chain activity into readable views of ledgers, transactions, contract invocations, and CAP-67 events, all indexed from live mainnet data. The build is production-grade: security-audited, load-tested for sub-200ms p95 responses, fully documented, and running on AWS with infrastructure-as-code.`,
      linkText: 'Read the announcement →',
      linkHref: '/blog/post/rumble-fish-grant-stellar-block-explorer/',
    },
    {
      badge: 'SCF #42 · $55,000',
      title: 'Stellar Prices API',
      description: `Price data on Stellar has been scattered across sources, formats, and assets, which creates work for every DeFi protocol, portfolio tracker, and price-sensitive app. We're building a unified Prices API to fix that: one source for real-time and historical price data across all Stellar assets, classic and SEP-41 Soroban tokens alike, with more than eight years of historical coverage.`,
      linkText: 'Read the announcement →',
      linkHref: '/blog/post/rumble-fish-grant-stellar-prices-API/',
    },
  ],
  quote: {
    text: `"Soroban is where the most exciting things on Stellar are happening right now: DeFi, new token standards, complex smart contract interactions. We're building this infrastructure because the ecosystem needs it, and because it's exactly the kind of challenge our team is built for."`,
    author: 'Marek Kowalski, CEO/CTO, Rumble Fish',
  },
  closing: '',
};
